module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/book/book-send/first-step/selected-book-list/selected-book-list.component.scss
// module id = ./src/app/book/book-send/first-step/selected-book-list/selected-book-list.component.scss
// module chunks = main